// The app's one loading animation (owner's pick, 24 Oct 2026: "B · Price line"): a purple price line draws itself up
// with a dot riding its tip. `overlay` floats it, centred, over a light dimmed backdrop — for a reload of a page that is
// already on screen (a date or broker change) — so the wait is seen, not a word under a heading. Styles: base.css .bl-*.
import React from 'react';

const PATH = 'M4 50 L30 38 L50 44 L74 22 L96 30 L126 8';

// `inline`: a compact line in place, for a panel or card loading inside a page (no card, no backdrop).
export default function BrandLoader({ message = 'Loading…', overlay = false, inline = false }) {
  if (inline) {
    return (
      <div className="bl-inline" role="status" aria-live="polite">
        <svg className="bl-line" width="52" height="24" viewBox="0 0 130 60" aria-hidden="true">
          <path d={PATH} />
          <circle r="6" style={{ offsetPath: `path("${PATH}")` }} />
        </svg>
        <span className="bl-msg">{message}</span>
      </div>
    );
  }
  const body = (
    <div className="bl-card" role="status" aria-live="polite">
      <svg className="bl-line" width="130" height="60" viewBox="0 0 130 60" aria-hidden="true">
        <path d={PATH} />
        <circle r="5" style={{ offsetPath: `path("${PATH}")` }} />
      </svg>
      <span className="bl-msg">{message}</span>
    </div>
  );
  return overlay ? <div className="bl-overlay">{body}</div> : <div className="bl-page">{body}</div>;
}
